// import {extent as d3_extent} from 'd3-array'
import { select as d3_select } from 'd3-selection'
import drawGradientRect from '../utils/drawGradientRect'

function LegendBehavior($root, chart, config = {}) {
  if (!chart.data) return

  let drawLegend = function(legend, d) {
    const isMobile = chart.config.isMobile
    const fontSize = (chart.config.AxisHelper.fontSize || (isMobile ? 11 : 12)) + 'px'
    let legendData = d.data

    if (d.type === 'sequential2' || d.type === 'sequential3') {
      let size = isMobile
        ? {
            width: 80,
            height: 10,
          }
        : { width: 90, height: 15 }

      drawGradientRect(legend.node(), chart.cachedColorScale, size)

      let labels = legend.selectAll('.label').data(['l', 'r'])
      labels = labels.merge(
        labels
          .enter()
          .append('div')
          .attr('class', 'label')
          .each(function(d) {
            d === 'l' && d3_select(this).lower()
          })
      )
      labels.style('margin', '0 5px').style('font-size', fontSize)

      labels.text(d => {
        let unit = chart.getUnit()
        if (d === 'l') {
          return chart.formatLegendValue
            ? chart.formatLegendValue(chart.cachedColorScale.domain()[0])
            : chart.cachedColorScale.domain()[0]
        } else {
          return chart.formatLegendValue
            ? chart.formatLegendValue(chart.cachedColorScale.domain()[1])
            : chart.cachedColorScale.domain()[1]
        }
        /* return d === 'l'
          ? chart.formatValue(chart.cachedColorScale.domain()[0], 'x')
          : chart.formatValue(chart.cachedColorScale.domain()[1], 'x') + (unit ? ' ' + unit : '') */
      })
    } else if (d.type === 'categorical' || d.type === 'lollipop') {
      let items = legend.selectAll('.legend-item').data(legendData, d => d.id)
      let itemsEnter = items
        .enter()
        .append('div')
        .attr('class', 'legend-item')
        .style('display', 'flex')
        .style('align-items', 'center')
        .style('margin', isMobile ? '1px 3px' : '2px 5px')

      // al a mierda la transicion... estropea el "sizeHelper"
      // items.exit().each(function (d) {
      //   let sel = d3_select(this)
      //   let rect = this.getBoundingClientRect()
      //   sel.style('top',rect.top+'px').style('left',rect.left+'px').style('position','absolute')
      // }).transition().style('opacity',0).remove()
      items
        .exit()
        .style('opacity', 0)
        .remove()

      itemsEnter
        .append('div')
        .attr('class', 'icon')
        .style('width', '10px')
        .style('height', '10px')

      itemsEnter.append('div').attr('class', 'label')
      items = items.merge(itemsEnter)

      if (d.type === 'lollipop') {
        items
          .select('.label')
          .text(d => d.label)
          .style('font-size', fontSize)

        items
          .select('.icon')
          .style('width', isMobile ? '15px' : '25px')
          .style('height', isMobile ? '15px' : '25px')
          // .style('margin', isMobile ? '0px' : '6px 8px 4px 4px')
          .style('background-size', 'cover')
          .style('background-position', 'center')
          .style('background-repeat', 'no-repeat')
          .style('background-image', (d, i) => {
            const svg =
              '<svg xmlns="http://www.w3.org/2000/svg" width="500" height="500">' +
              '<polygon fill="' +
              (i === 0
                ? chart.config.ItemsHelper.colorDict.all.color
                : chart.config.colorMode == 'normal'
                ? '#7C4DFF'
                : '#bbb') +
              '" stroke="#fff" stroke-width="0" points="' +
              chart.candyPolygonPoints(i - 1, 250) +
              '" style="transform: translate(250px, 250px)"></polygon></svg>'
            return (
              'url("data:image/svg+xml;base64,' + btoa(unescape(encodeURIComponent(svg))) + '")'
            )
          })
        return
      }

      items
        .select('.label')
        .text(d => d.id)
        .style('font-size', fontSize)

      items
        .select('.icon')
        .style('margin', isMobile ? '0px 4px 1px' : '6px 8px 4px 4px') //BASURA ESTE 6px, (es porque la fuente no esta "bien centrada" creo)
        .transition()
        .style('background', dd => chart.color(dd, d.index))

      let icon = d.data.icon || config.icon
      if (icon === 'circle') {
        items
          .select('.icon')
          .classed('circle', true)
          .style('width', '10px')
          .style('height', '10px')
          .style('border-radius', '10px')
      } else if (icon === 'line') {
        items
          .select('.icon')
          .classed('rect', true)
          .style('width', '10px')
          .style('height', '2px')
      } else {
        items
          .select('.icon')
          .classed('dented-rect', true)
          .style('width', '10px')
          .style('height', '10px')
          .style('border-radius', '3px 0 3px 0')
      }
    } else if (d.type === 'size') {
      let items = legend.selectAll('.legend-item').data(legendData)
      let itemsEnter = items
        .enter()
        .append('div')
        .attr('class', 'legend-item')
        .style('display', 'flex')
        .style('align-items', 'center')
        .style('margin', '5px')
      items.exit().remove()

      itemsEnter
        .append('div')
        .attr('class', 'icon')
        .style('width', '10px')
        .style('height', '10px')

      itemsEnter
        .append('div')
        .attr('class', 'label')
        .style('font-size', fontSize)
      items = items.merge(itemsEnter)

      items.select('.label').text(d => d.id)
      items
        .select('.icon')
        .style('margin', '6px 8px 4px 4px') //BASURA ESTE 6px, (es porque la fuente no esta "bien centrada" creo)
        .transition()
        .style('background', '#ddd')

      items
        .select('.icon')
        .classed('circle', true)
        .style('width', d => d.value + 'px')
        .style('height', d => d.value + 'px')
        .style('border-radius', d => d.value + 'px')
    }
  }

  let legendDatas = (chart.getLegendData && chart.getLegendData()) || chart.data
  if (Array.isArray(legendDatas))
    legendDatas = [
      {
        id: chart.config.ItemsHelper.colorScale,
        data: legendDatas,
        lastDates: legendDatas.lastDates,
      },
    ]
  else
    legendDatas = Object.keys(legendDatas)
      .map((key, i) => ({
        id: key !== 'lastDates' ? chart.config.ItemsHelper.colorScale[i] + '_' + key : null,
        data: legendDatas[key],
      }))
      .filter(d => d.id)
  legendDatas.forEach((ld, i) => {
    ld.type =
      ld.data.type === 'lollipop'
        ? 'lollipop'
        : ld.data.type || Array.isArray(chart.config.ItemsHelper.colorScale)
        ? chart.config.ItemsHelper.colorScale[i]
        : chart.config.ItemsHelper.colorScale
    ld.index = i
  })

  let legends = d3_select($root)
    .selectAll('.legend')
    .data(legendDatas, d => d.id)
  legends.exit().remove()
  let legendsEnter = legends
    .enter()
    .append('div')
    .attr('class', 'legend')
  legendsEnter
    .style('opacity', 0)
    .transition()
    .duration(1000)
    .style('opacity', 1)
  legends = legends.merge(legendsEnter)
  legends
    .style('display', 'flex')
    .style('flex-wrap', 'wrap')
    .style('align-items', 'center')
    .style('margin-top', '5px')

  d3_select($root)
    .select('.dates-legend')
    .remove()

  var showDatesLegend = false
  legends.each(function(d) {
    showDatesLegend ||= d.lastDates
  })

  if (showDatesLegend) {
    let datesLegend = d3_select($root)
      .append('div')
      .attr('class', 'dates-legend')
      .text('* Relates to a less-recent time period.')

    datesLegend
      .style('opacity', 0)
      .transition()
      .duration(1000)
      .style('opacity', 1)

    datesLegend.style('margin-left', '10px').style('margin-top', '15px')
  } else {
    var legend = $root.getElementsByClassName('dates-legend')[0]
    if (legend) legend.parentElement.removeChild(legend)
  }

  legends.each(function(d) {
    drawLegend(d3_select(this), d)
  })
}

LegendBehavior.defaultConfig = {
  index: 201,
  /**
   * Show or hide the legend of the chart.
   */
  showLegend: {
    type: Boolean,
    default: false,
    exposed: true,
  },
  icon: {
    type: [String],
    options: ['square', 'circle', 'line'],
    default: 'square',
  },
}
LegendBehavior.configName = 'LegendBehavior'

export default LegendBehavior
